import { render, staticRenderFns } from "./Tires.vue?vue&type=template&id=99479d68&scoped=true"
import script from "./Tires.vue?vue&type=script&lang=js"
export * from "./Tires.vue?vue&type=script&lang=js"
import style0 from "./Tires.vue?vue&type=style&index=0&id=99479d68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99479d68",
  null
  
)

export default component.exports